import * as React from 'react';

export const MenubarContext = React.createContext(null);

export const SubmenuContext = React.createContext(null);

export const MenuItemContext = React.createContext(null);